import { render, staticRenderFns } from "./RedeemSetting.vue?vue&type=template&id=510e27ad"
import script from "./RedeemSetting.vue?vue&type=script&lang=js"
export * from "./RedeemSetting.vue?vue&type=script&lang=js"
import style0 from "./RedeemSetting.vue?vue&type=style&index=0&id=510e27ad&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports